import { DashboardPage } from "./DashboardPage";

export function HomePage() {
  return <DashboardPage />;
}
